import { CHART_ROLES } from 'constants/chart-roles';

const FETCH_ITEM_DATA_ERRORS = Object.freeze({
  DATASOURCE_NOT_FOUND:
    'This data source could not be found or you do not have permission to access it',
  MISSING_DATASOURCE:
    'The data source used by this chart does not exist, or you do not have permission to access it',
  TIMEOUT_ERROR: 'A timeout occurred while loading data for this chart',
  GENERAL_SERVER_ERROR: 'An error occurred while loading data for this chart',
});

const DEFAULT_MAX_RESPONSE_SIZE = 5000;

const FETCH_ITEM_DATA_WARNINGS = Object.freeze({
  MAX_RESPONSE_SIZE: (chartType, maxDocLimit = DEFAULT_MAX_RESPONSE_SIZE) => {
    const { displayName } = CHART_ROLES.find(chart => chart.name === chartType);
    return `This chart may be displaying incomplete data. The maximum query response size of ${maxDocLimit} documents for ${displayName} type charts has been reached.`;
  },
});

// A timeout (5 mins) for item data requests, which is set for the following reasons:
// - It needs to be longer than the default Stitch timeout (60 seconds).
// - browsers enforce a maximum number of concurrent requests to the same domain - typically 6 after which, requests are queued.
//   Multiple queued requests would not fire for some time, we're going with 5 mins to give enough buffer for the queued requests to fulfil (see CHARTS-2637 for more details)
const FETCH_ITEM_DATA_REQUEST_TIMEOUT = 300000;

export {
  DEFAULT_MAX_RESPONSE_SIZE,
  FETCH_ITEM_DATA_ERRORS,
  FETCH_ITEM_DATA_WARNINGS,
  FETCH_ITEM_DATA_REQUEST_TIMEOUT,
};
